import { render, staticRenderFns } from "./TaskStatusMenu.vue?vue&type=template&id=6627701e"
import script from "./TaskStatusMenu.vue?vue&type=script&lang=ts"
export * from "./TaskStatusMenu.vue?vue&type=script&lang=ts"
import style0 from "./TaskStatusMenu.vue?vue&type=style&index=0&id=6627701e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports